import { api } from '../services/api.ts';

// Define the feedback data interface
export interface FeedbackData {
  message: string;
  is_breaking: boolean;
}

// Define the feedback response interface
export interface FeedbackResponse {
  id: string;
  user_id: string | null;
  user_email: string | null;
  message: string;
  is_breaking: boolean;
  created_at: string;
  updated_at: string;
}

// Function to submit feedback
export const submitFeedback = async (data: FeedbackData): Promise<FeedbackResponse> => {
  try {
    const response = await api.post('/api/feedback', data);
    return response.data.data;
  } catch (error) {
    console.error('Error submitting feedback:', error);
    throw error;
  }
};